var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      !_vm.shouldShowTOTPInput
        ? _c(
            "LoginCard",
            {
              attrs: {
                header: "Administrator Password Reset",
                showCustomLogo: false,
              },
            },
            [
              _vm.errorMessage
                ? _c("Alert", {
                    model: {
                      value: _vm.errorMessage,
                      callback: function ($$v) {
                        _vm.errorMessage = $$v
                      },
                      expression: "errorMessage",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isExpired
                ? _c(
                    "Alert",
                    {
                      attrs: { centered: "" },
                      on: { updateMessage: _vm.handleHideExpiredAlert },
                    },
                    [
                      _c("p", { class: _vm.$style.alertHeader }, [
                        _vm._v(
                          "\n        This password reset link has expired.\n      "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { class: _vm.$style.alertText }, [
                        _vm._v(
                          "\n        Check your inbox for the most recent link or reset your password\n        again. For security purposes, this link expires after 1 hour.\n      "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("ResetPassword", {
                ref: _vm.formRef,
                attrs: {
                  clientType: _vm.clientType,
                  isLoading: _vm.isLoading,
                  email: _vm.$route.query.email,
                  error: _vm.errorMessage,
                  form: _vm.form,
                  disabled: _vm.isDisabled,
                  submit: _vm.submit,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowTOTPInput
        ? _c(
            "VerifyTOTP",
            _vm._b(
              {
                attrs: {
                  clientType: _vm.clientType,
                  requestKey: _vm.$route.query.key,
                  confirmationCode: _vm.requestKey,
                  passwordResetInfo: _vm.form,
                  shouldShowCustomLogo: true,
                  disabled: false,
                  mfaDisplayText: _vm.mfaDisplayText,
                },
              },
              "VerifyTOTP",
              _vm.$route.query,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.shouldShowTOTPInput ? _c("LogoIcon") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }